var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconMenuInfo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_2068",
    "data-name": "Group 2068",
    transform: "translate(-1380.25 -530.883)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2219",
    "data-name": "Path 2219",
    d: "M16,0A16,16,0,1,1,0,16,16,16,0,0,1,16,0Z",
    transform: "translate(1380.25 530.883)",
    fill: "#f4f3f0",
    opacity: 0
  }), /*#__PURE__*/React.createElement("path", {
    id: "info",
    d: "M18.886,11.21a7.675,7.675,0,1,0,0,15.349A7.837,7.837,0,0,0,24.1,24.52a7.493,7.493,0,0,0,2.464-5.636A7.673,7.673,0,0,0,18.886,11.21Zm.89,12a.89.89,0,1,1-1.781,0V17.518a.89.89,0,0,1,1.781,0Zm-.89-7.575a.984.984,0,1,1,.983-.983A.985.985,0,0,1,18.886,15.637Z",
    transform: "translate(1377.365 527.998)",
    fill: "#816920"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMenuInfo);
export default __webpack_public_path__ + "static/media/icon-menu-info.48c325e9.svg";
export { ForwardRef as ReactComponent };